/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { TrekksoftClientCredential } from './TrekksoftClientCredential';
import {
    TrekksoftClientCredentialFromJSON,
    TrekksoftClientCredentialFromJSONTyped,
    TrekksoftClientCredentialToJSON,
    TrekksoftClientCredentialToJSONTyped,
} from './TrekksoftClientCredential';

/**
 * 
 * @export
 * @interface ListTrekksoftClientCredentialsResponse
 */
export interface ListTrekksoftClientCredentialsResponse {
    /**
     * 
     * @type {Array<TrekksoftClientCredential>}
     * @memberof ListTrekksoftClientCredentialsResponse
     */
    data: Array<TrekksoftClientCredential>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListTrekksoftClientCredentialsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListTrekksoftClientCredentialsResponse interface.
 */
export function instanceOfListTrekksoftClientCredentialsResponse(value: object): value is ListTrekksoftClientCredentialsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListTrekksoftClientCredentialsResponseFromJSON(json: any): ListTrekksoftClientCredentialsResponse {
    return ListTrekksoftClientCredentialsResponseFromJSONTyped(json, false);
}

export function ListTrekksoftClientCredentialsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTrekksoftClientCredentialsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TrekksoftClientCredentialFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListTrekksoftClientCredentialsResponseToJSON(json: any): ListTrekksoftClientCredentialsResponse {
      return ListTrekksoftClientCredentialsResponseToJSONTyped(json, false);
  }

  export function ListTrekksoftClientCredentialsResponseToJSONTyped(value?: ListTrekksoftClientCredentialsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(TrekksoftClientCredentialToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

